import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { ProfileSettingsProvider } from '../../providers/profile-settings/profile-settings';
import { NavController, ToastController, AlertController } from 'ionic-angular';
import { PasswordStrengthBarModule } from 'ng2-password-strength-bar';
import { Api, User } from '../../providers/providers';

/**
 * Generated class for the ProfileAccountComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'profile-account',
  templateUrl: 'profile-account.html',
})
export class ProfileAccountComponent implements OnInit {
  @ViewChild('resetForm') form;
  @ViewChild('newPassword') newPass;
  public barLabel: string = '';
  public myColors = ['#DD2C00', '#FF6D00', '#FFD600', '#AEEA00', '#00C853'];
  account: any = {};
  currentUser: any;
  guest = true;

  constructor(
    public navCtrl: NavController,
    public toastCtrl: ToastController,
    private profileSettingsProvider: ProfileSettingsProvider,
    private alertCtrl: AlertController,
    private user: User
  ) {}

  ngOnInit(): void {
    this.getCurrentUser();
  }
  async getCurrentUser() {
    this.profileSettingsProvider.getCurrentUser().subscribe(res => {
      this.guest = res.guest;
    });
  }
  logOut() {
    this.user.logout().subscribe(() => {
      this.navCtrl.setRoot('WelcomePage');
    });
  }

  deleteUser(): void {
    let confirm = this.alertCtrl.create({
      title: 'Deleting account!!!',
      message:
        'Are you sure you want to delete your account this process is irreversible',
      cssClass: 'welcome-message',
      buttons: [
        {
          text: 'Not Now',
          handler: () => {
            console.log('You opted out ');
          },
        },
        {
          text: "I'm sure",
          handler: () => {
            this.profileSettingsProvider.deleteAcount(false).subscribe(
              res => {
                this.logOut();
              },
              err => {
                this.toastCtrl
                  .create({
                    message:
                      'Something went wrong  trying to delete account please try again later',
                    duration: 3000,
                    position: 'top',
                  })
                  .present();
              }
            );
          },
        },
      ],
    });

    confirm.present();
  }

  changePassword(currentPassword: string, newPassword: string): void {
    this.profileSettingsProvider
      .changePassword(currentPassword, newPassword)
      .subscribe(
        () => {
          this.account.password = '';
          this.account.newPassword = '';
          this.account.confirmPassword = '';

          this.form.resetForm();
          setTimeout(() => {
            this.navCtrl.setRoot('ProfileSettingsPage');
          }, 3000);

          this.toastCtrl
            .create({
              message: 'User password changed!',
              duration: 3000,
              position: 'top',
            })
            .present();
        },
        err => {
          this.toastCtrl
            .create({
              message:
                'Error trying to change the password Please check all the fields and try again',
              duration: 3000,
              position: 'top',
            })
            .present();
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/components/profile-account/profile-account.ts